import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-navbar',
  imports: [CommonModule],
  template: `
    <nav 
      [class]="navbarClasses"
      [attr.role]="'navigation'"
      [attr.aria-label]="ariaLabel()">
      <div [class]="containerClasses">
        @if (brand()) {
          <div class="flex items-center">
            <ng-content select="[brand]"></ng-content>
          </div>
        }
        
        <div class="flex items-center gap-4 flex-1">
          <ng-content></ng-content>
        </div>
        
        @if (showActions()) {
          <div class="flex items-center gap-2">
            <ng-content select="[actions]"></ng-content>
          </div>
        }
      </div>
    </nav>
  `,
  styles: []
})
export class NavbarComponent {
  brand = input<boolean>(true);
  showActions = input<boolean>(true);
  variant = input<'default' | 'elevated' | 'outlined'>('default');
  sticky = input<boolean>(false);
  ariaLabel = input<string>('Main navigation');

  get navbarClasses(): string {
    const classes = [
      'w-full',
      'bg-white',
      'dark:bg-gray-800',
      'border-b',
      'border-gray-200',
      'dark:border-gray-700',
      'transition-colors',
      'duration-200'
    ];

    if (this.sticky()) {
      classes.push('sticky', 'top-0', 'z-50');
    }

    if (this.variant() === 'elevated') {
      classes.push('shadow-md');
    } else if (this.variant() === 'outlined') {
      classes.push('border-2');
    }

    return classes.join(' ');
  }

  get containerClasses(): string {
    return 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between';
  }
}

